import { render, staticRenderFns } from "./EnrollExamRoomSetting.vue?vue&type=template&id=d06d5f52"
import script from "./EnrollExamRoomSetting.vue?vue&type=script&lang=js"
export * from "./EnrollExamRoomSetting.vue?vue&type=script&lang=js"
import style0 from "./EnrollExamRoomSetting.vue?vue&type=style&index=0&id=d06d5f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports